/* HURCANN — hover-open desktop navigation (mega menu + dropdowns)
   Touch devices keep native click/tap behavior. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var CLOSE_DELAY = 180;

  function setup(details) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    var timer = null;

    function open() {
      clearTimeout(timer);
      // close any sibling menus first
      document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
        if (d !== details) close(d);
      });
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      }
    }

    function close(d) {
      var el = d || details;
      el.removeAttribute('open');
      var s = el.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', function () {
      timer = setTimeout(function () { close(); }, CLOSE_DELAY);
    });

    // clicking the summary link while open should follow the parent URL if it has one
    summary.addEventListener('click', function (e) {
      var url = summary.getAttribute('data-url') || (summary.querySelector('a') && summary.querySelector('a').href);
      if (details.hasAttribute('open') && url && url !== '#') {
        // allow default details toggle when no url
      }
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
